import { useEffect } from "react";

import { useLocation } from "react-router-dom";

import { scrollMargin } from "../../styles";

export const useScrollToTop = (path: string) => {
    const location = useLocation();

    useEffect(() => {
        if (!location.hash) {
            window.scrollTo(0, 0);
        } else if (location.hash.startsWith("#")) {
            const fragment = document.querySelector(location.hash);
            if (fragment) {
                const { top } = fragment.getBoundingClientRect();
                window.scroll({
                    top: top + window.scrollY - scrollMargin.top,
                    behavior: "smooth"
                });
            }
        }
    }, [path, location]);
};
